import { ReactNode, useEffect } from 'react';
import { ContactLinkCategoriesApi } from '@/shared/api/ContactLinkCategoriesApi.ts';
import { ContactLinkCategory } from '@/shared/model/contactLinkCategory.ts';
import { ModalSize, useModal } from '@fs/uikit-react';
import { ApiError } from '@/services/api';

export let refreshContactLinkCategories = () => {};
export let openContactLinkCategoryModal: (size: ModalSize, title: string, content: ReactNode) => void;

export const useInit = (
  setItems: (value: ContactLinkCategory[]) => void,
  setLoading: (value: boolean) => void,
  setError: (value: ApiError | null) => void
) => {
  openContactLinkCategoryModal = useModal().openModal;

  useEffect(() => {
    refreshContactLinkCategories = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await ContactLinkCategoriesApi.getAll();
        setItems(response.data as ContactLinkCategory[]);
      } catch (err) {
        setError(err as ApiError);
        console.error('Error fetching contact link categories:', err);
      } finally {
        setLoading(false);
      }
    };
  }, [setItems, setLoading, setError]);
};
